var incognitoTest, polyfillStore, tracky;

tracky = require('../../../core/frontend/groupon_modules/trackEvent');


/*
 * In-memory mock for local / sessionStorage
 * It is not persistent across pages.
 */

polyfillStore = function() {
  Storage.prototype._data = {};
  Storage.prototype.setItem = function(id, val) {
    return this._data[id] = String(val);
  };
  Storage.prototype.getItem = function(id) {
    if (this._data.hasOwnProperty(id)) {
      return this._data[id];
    } else {
      return null;
    }
  };
  Storage.prototype.removeItem = function(id) {
    return delete this._data[id];
  };
  Storage.prototype.clear = function() {
    return this._data = {};
  };
};


/*
 * Tries to use the sessionStorage setter, which fails in Safari incognito
 *
 * @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
 */

incognitoTest = function(env) {
  var ref, ref1;
  if (env == null) {
    env = 'desktop';
  }
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
      sessionStorage.setItem('incognitotest', 'test');
    }
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref = Groupon.PageFlags) != null) {
        ref.isIncognito = false;
      }
    }
  } catch (error) {
    tracky("ls-likely-incognito-session-" + env);
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref1 = Groupon.PageFlags) != null) {
        ref1.isIncognito = true;
      }
    }
    polyfillStore();
  }
};

module.exports = {
  incognitoTest: incognitoTest,
  polyfillStore: polyfillStore
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9pbmNvZ25pdG8uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9pbmNvZ25pdG8uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBQSxHQUFTLE9BQUEsQ0FBUSxtREFBUjs7O0FBRVQ7Ozs7O0FBSUEsYUFBQSxHQUFnQixTQUFBO0VBQ2QsT0FBTyxDQUFBLFNBQUUsQ0FBQSxLQUFULEdBQWlCO0VBQ2pCLE9BQU8sQ0FBQSxTQUFFLENBQUEsT0FBVCxHQUFtQixTQUFDLEVBQUQsRUFBSyxHQUFMO1dBQWEsSUFBSSxDQUFDLEtBQU0sQ0FBQSxFQUFBLENBQVgsR0FBaUIsTUFBQSxDQUFPLEdBQVA7RUFBOUI7RUFDbkIsT0FBTyxDQUFBLFNBQUUsQ0FBQSxPQUFULEdBQW1CLFNBQUMsRUFBRDtJQUFRLElBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxjQUFYLENBQTBCLEVBQTFCLENBQUg7YUFBc0MsSUFBSSxDQUFDLEtBQU0sQ0FBQSxFQUFBLEVBQWpEO0tBQUEsTUFBQTthQUEwRCxLQUExRDs7RUFBUjtFQUNuQixPQUFPLENBQUEsU0FBRSxDQUFBLFVBQVQsR0FBc0IsU0FBQyxFQUFEO1dBQVEsT0FBTyxJQUFJLENBQUMsS0FBTSxDQUFBLEVBQUE7RUFBMUI7RUFDdEIsT0FBTyxDQUFBLFNBQUUsQ0FBQSxLQUFULEdBQWlCLFNBQUE7V0FBRyxJQUFJLENBQUMsS0FBTCxHQUFhO0VBQWhCO0FBTEg7OztBQU9oQjs7Ozs7O0FBS0EsYUFBQSxHQUFnQixTQUFDLEdBQUQ7QUFDZCxNQUFBOztJQURlLE1BQU07O0FBQ3JCOztNQUNFLGNBQWMsQ0FBRSxPQUFoQixDQUF3QixlQUF4QixFQUF5QyxNQUF6Qzs7OztXQUNrQixDQUFFLFdBQXBCLEdBQWtDOztLQUZwQztHQUFBLGFBQUE7SUFJRSxNQUFBLENBQU8sOEJBQUEsR0FBZ0MsR0FBdkM7OztZQUNrQixDQUFFLFdBQXBCLEdBQWtDOzs7SUFDbEMsYUFBQSxDQUFBLEVBTkY7O0FBRGM7O0FBVWhCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YsZUFBQSxhQURlO0VBRWYsZUFBQSxhQUZlIn0=
